<template>
  <div class="new content-wrapper">
    <h1>Create New Task</h1>
    <Task :task="task"></Task>

    <div class="button-container">
      <button :disabled="disableButtons" class="button" @click="create('create this task')">Create</button>
    </div>
  </div>
</template>

<script>
import Task from '@/components/task'
import requiredFields from '@/services/requiredFields'
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'new',
  props: {
    type: String,
    flair: String,
    market: String,
    site: String,
  },
  data() {
    return {
      task: {
        id: '',
        type: '',
        status: 'available',
        isPriority: false,
        createdBy: '',
        orderedBy: '',
        claimedBy: '',
        // claimedAt: '', // purposely outcommented to ensure it can be set by the google cloud function
        // createdAt: '', // purposely outcommented to ensure it can be set by the google cloud function
        // deadlineAt: '', // purposely outcommented to ensure it can be set by the google cloud function
        // exportedAt: '', // purposely outcommented to ensure it can be set by the google cloud function
        // seoVerifiedAt: '', // purposely outcommented to ensure it can be set by the google cloud function
        marketId: '',
        flair: '',
        copyscapeScore: '',
        notesFreelancers: '',
        notesInternal: '',
        fixedPrice: 0,
        bonusPrice: 0,
        wordCount: 0,
        templateUrl: '',
        wordCountMin: 0,
        wordCountMax: 0,
        content: {
          htmlTitle: '',
          htmlMetaDescription: '',
          title: '',
          keyword: '',
          siteIds: [''],
          url: '',
          topic: '',
          brandId: '',
          summary: '',
          bonusReview: '',
          gameSelectionReview: '',
          pros: ['', '', ''],
          cons: ['', ''],
          faq: {
            title: '',
            qas: [
              {
                question: '',
                answer: '',
              },
            ],
          },
          howTo: {
            headline: '',
            description: '',
            time: '00:00',
            tools: [''],
            supplies: [''],
            steps: [
              {
                headline: '',
                name: '',
                description: '',
              },
            ],
          },
          prosConsShortcode: {
            headline: '',
            description: '',
            pros: [''],
            cons: [''],
          },
          anchors: [
            {
              link: '',
              text: '',
            },
          ],
        },
      },
      disableButtons: false,
    }
  },
  created() {
    if (this.$props.type) this.task.type = this.$props.type
    if (this.$props.site) this.task.content.siteIds[0] = this.$props.site
    if (this.$props.flair) this.task.flair = this.$props.flair
    if (this.$props.market) this.task.marketId = this.$props.market
  },
  methods: {
    ...mapActions(['createTask']),

    async create(message) {
      const fields = [
        { content: this.task.type, name: 'Type' },
        { content: this.task.content.siteIds[0], name: 'Site' },
        { content: this.task.wordCountMin, name: 'Word count min' },
        { content: this.task.wordCountMax, name: 'Word count max' },
      ]

      if (this.task.type === 'review') fields.push({ content: this.task.content.brandId, name: 'Brand' })
      if (this.task.type === 'seo') fields.push({ content: this.task.content.keyword, name: 'Keyword' })
      if (this.task.type === 'linkbuilding') fields.push({ content: this.task.orderedBy, name: 'Ordered By' })

      this.disableButtons = true
      if (requiredFields.fieldsCompleted(fields)) {
        await this.$dialog.confirm('Are you sure you want to ' + message + '?')
        try {
          const task = await this.createTask({ task: this.task })

          this.$notify({
            text: 'Successfully created task',
            type: 'success',
          })

          this.$router.push({ name: 'taskId', params: { id: task.id } })
        } catch (error) {
          this.$notify({
            text: 'Failed to save task',
            type: 'error',
          })
        }
      } else {
        this.$dialog.alert(requiredFields.fieldsMessage(fields), { html: true })
      }

      this.disableButtons = false
    },
  },
  components: {
    Task,
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared-styles/button.scss';

.button-container {
  display: flex;
  margin-left: auto;
}
</style>
